import { ref, set } from "firebase/database";
import { database } from '../firebaseConfig';

const writeUserData = (userId, email, username, password, SignInType, createdAt, API_KEY) => {
  set(ref(database, 'Users/' + userId), {
    UCI: userId,
    EmailAddress: email,
    Username: username,
    Password: password,
    SignInType: SignInType,
    CreatedAt: new Date(createdAt).toLocaleString("en-US", { timeZone: "America/New_York" }),
    APIKey: API_KEY,
  })
  .then(() => {
    //console.log("User data written successfully");
  })
  .catch((error) => {
    //console.error("Error writing user data: ", error);
  });
};

// Example usage (commented out):
// writeUserData('userid123', 'user@example.com', 'user123', 'password123', Date.now(), '1234567890');

const writeDailySMSCountData = (userId) => {
  set(ref(database, 'DailySmsCount/' + userId), {
    CurrentCount: 0,
    Date: new Date().toISOString().split("T")[0], // Format YYYY-MM-DD
    Limit: 100,
  })
  .then(() => {
    //console.log("User data written successfully");
  })
  .catch((error) => {
    //console.error("Error writing user data: ", error);
  });
};

const writeWelcomeEmail = async (userEmail) => {
  try {
    // Make the fetch call and await the response
    const response = await fetch("https://us-central1-smstextr.cloudfunctions.net/welcomeemail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        to: userEmail,
      }),
    });

    // Check if the response is OK (status 200)
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // Wait for the response to be parsed as JSON
    const data = await response.json();
    console.log(data); // Log the parsed data

    // You can also handle success/failure here
    if (data.success) {
      console.log("Email sent successfully");
    } else {
      console.log("Failed to send email:", data.message);
    }
  } catch (error) {
    console.error("Error sending email:", error);
    alert('There was an error sending the email. Please try again.');
  }
};


export { writeUserData };
export { writeDailySMSCountData };
export { writeWelcomeEmail };
